import { isEmptyOrNil } from 'libs/empty'

export const resizeAvatar_80 = (src = null) => {
  //imagekit url
  return isEmptyOrNil(src) ? '' : `${src}?tr=w-80,c-at_max,f-jpg,q-30`
}

export const resizeAvatar_250 = (src = null) => {
  const isBase64 = /^data:image\/[a-zA-Z]+;base64,/.test(src)
  if (isBase64) {
    return src
  }
  return isEmptyOrNil(src) ? '' : `${src}?tr=w-250,c-at_max,q-30`
}

export const resize_250_q40 = (src = null) => {
  const isBase64 = /^data:image\/[a-zA-Z]+;base64,/.test(src)
  if (isBase64) {
    return src
  }
  return isEmptyOrNil(src) ? '' : `${src}?tr=w-250,c-at_max,f-jpg,q-40`
}
